import React from 'react';
import { generatePath, useParams } from 'react-router-dom';

import { rootRoutes } from '../../../app/routers/rootRoutes';
import { TaskGroups } from '../../../entities/tasks';
import { getGroupedTaskName } from '../../lib';
import { TaskCounts } from '../../model/tasks/types';
import { TaskNavigationLink } from '../TaskNavigationLink';
import styles from './GroupedTaskNavigation.module.css';

type Props = {
  countsMap: Record<string, TaskCounts>;
  groupId: string;
  groupKeys: string[];
};

export const GroupedTaskNavigation: React.FC<Props> = ({ countsMap, groupKeys }) => {
  const { groupId } = useParams();

  if (!countsMap || !groupId) {
    return null;
  }

  const getPath = (groupKey: string) => {
    if (groupKey === TaskGroups.None) {
      return rootRoutes.taskList;
    }

    return generatePath(rootRoutes.filteredTaskList, { groupId, groupKey });
  };

  return (
    <nav data-id="taskNavigation">
      {groupKeys?.map((id) => {
        return !countsMap[id] ? (
          <h2 data-id="taskNavItem" className={styles.divider}>
            {id}
          </h2>
        ) : (
          <TaskNavigationLink
            count={countsMap[id].allTaskCounter}
            dataId="taskNavItem"
            key={id}
            name={getGroupedTaskName(groupId, id)}
            to={getPath(id)}
          />
        );
      })}
    </nav>
  );
};
